export const API_URL = "apiUrl";
export const AUTH_TOKEN = "authToken";
export const BEARER = "Bearer";